type AlertProps = {
	message: string;
	backgroundColor?: string;
	borderColor?: string;
	className?: string;
};

export function Alert({
	message,
	backgroundColor,
	borderColor,
	className = "",
}: AlertProps) {
	return (
		<div
			className={`pf-alert ${className}`.trim()}
			role="status"
			style={{ backgroundColor, borderColor }}
		>
			<svg
				className="pf-alert__icon"
				viewBox="0 0 20 20"
				aria-hidden="true"
				focusable="false"
			>
				<path
					fill="currentColor"
					d="M10.9 2.66a1.03 1.03 0 0 0-1.8 0L.96 16.9c-.4.7.1 1.57.9 1.57h16.28c.8 0 1.3-.87.9-1.57L10.9 2.66Z"
				/>
				<path
					fill="#ffffff"
					d="M9.25 7.05h1.5v5h-1.5zM10 13.35a.95.95 0 1 1 0 1.9.95.95 0 0 1 0-1.9Z"
				/>
			</svg>
			<p>{message}</p>
		</div>
	);
}
